// @flow

import React, { type Node } from 'react';
import { MapLink } from '../commons/voucher/map-link';
import iconOxxo from './oxxopay-icon.svg';

export function OxxopayMapLink(): Node {
  return (
    <MapLink
      imgSrc={iconOxxo}
      link="https://print.ebanx.com/print/oxxo/map"
      message="Haz click y encuentra el OXXO más cercano para realizar el pago"
    />
  );
}
